module.exports = "/static/Images/images/flag-en.png";